import { format } from 'date-fns';
const baseURL = process.env.REACT_APP_POST_URL;
const webURL = process.env.REACT_APP_WEB_URL;

const columns = [
    {
        field: 'id',
        headerName: 'ID',
        width: 40,
        type: 'number',
        sortable: true,
    },
    {
        field: 'project_name',
        headerName: 'Project Name',
        width: 300,
        editable: true,
        renderCell: (params) => (
            <span className="text-blue-500 font-semibold cursor-pointer">
                {params.value}
            </span>
        ),
    },
    {
        field: 'slug',
        headerName: 'Live At',
        width: 120,
        editable: true,
        renderCell: (params) => (
            params.value ? (
                <a href={`${webURL}/${params.value}`} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                    URL
                </a>
            ) : (
                <span className="text-gray-500 italic">No Data</span>
            )
        ),
    },
    // {
    //     field: 'user_id',
    //     headerName: 'User ID',
    //     width: 150,
    //     editable: true,
    // },
    // {
    //     field: 'category',
    //     headerName: 'Category',
    //     width: 180,
    //     editable: true,
    // },
    {
        field: 'image',
        headerName: 'Image URL',
        width: 100,
        editable: true,
        renderCell: (params) => (
            params.value ? (
                <img
                    src={`${baseURL}/img/gallery/${params.value}`}
                    alt="Post Image"
                    className="h-30 w-30 object-cover rounded-lg"
                />
            ) : (
                <span className="text-gray-500 italic">No Image</span>
            )
        ),
    },
    {
        field: 'youtube_link',
        headerName: 'YouTube Link',
        width: 120,
        editable: true,
        renderCell: (params) => (
            params.value ? (
                <a href={params.value} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                    Watch Video
                </a>
            ) : (
                <span className="text-gray-500 italic">No Data</span>
            )
        ),
    },
    {
        field: 'offer',
        headerName: 'Preview',
        width: 100,
        editable: true,
        renderCell: (params) => (
            params.value ? (
                <a href={params.value} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                    Preview
                </a>
            ) : (
                <span className="text-gray-500 italic">No Data</span>
            )
        ),
    },
    {
        field: 'price',
        headerName: 'Price',
        width: 100,
        type: 'number',
        editable: true,
    },
    // {
    //     field: 'razor_price',
    //     headerName: 'Razor Price',
    //     width: 100,
    //     type: 'number',
    //     editable: true,
    // },
    {
        field: 'status',
        headerName: 'Status',
        width: 100,
        editable: true,
    },
    // {
    //     field: 'slug',
    //     headerName: 'Slug',
    //     width: 200,
    //     editable: true,
    // },
    {
        field: 'file_link',
        headerName: 'File Link',
        width: 250,
        editable: true,
        renderCell: (params) => (
            params.value ? (
                <a href={params.value} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                    Download File
                </a>
            ) : (
                <span className="text-gray-500 italic">No Data</span>
            )
        ),

    },
    {
        field: 'short_description',
        headerName: 'Short Description',
        width: 300,
        editable: true,
    },
    // {
    //     field: 'description',
    //     headerName: 'Description',
    //     width: 400,
    //     editable: true,
    // },
    {
        field: 'created_at',
        headerName: 'Created At',
        width: 200,
        type: 'string',
        valueGetter: (value, row) => {
            return format(new Date(value), 'dd MMM yyyy, hh:mm a');
        }
    },
    {
        field: 'updated_at',
        headerName: 'Updated At',
        width: 200,
        type: 'string',
        valueGetter: (value, row) => {
            return format(new Date(value), 'dd MMM yyyy, hh:mm a');
        }
    },
];

export default columns;
